// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"OQ-z","upvoteIcon":"PQ-z","downvoteIcon":"QQ-z","feedbackIcon":"RQ-z"};